"use client"
import { useIframeEvent } from "@/context/IframeContext"
import { signout } from "@/lib/data/customer"
import { cn } from "@/lib/utils"
import { useTranslate } from "@tolgee/react"

type LogoutButtonProps = {
  unstyled?: boolean
} & React.ButtonHTMLAttributes<HTMLButtonElement>

export const LogoutButton: React.FC<LogoutButtonProps> = ({
  unstyled,
  className,
  children,
}) => {
  const { t } = useTranslate()
  const { sentLogoutDataToIframe } = useIframeEvent();

  const handleLogout = async () => {
    sentLogoutDataToIframe();
    await signout();
  }

  return (  
    <button
      onClick={handleLogout}
      className={cn(
        !unstyled && "label-md uppercase px-4 py-3 my-3 md:my-0",
        className
      )}
    >
      {children || t("user_dropdown.logout")}
    </button>
  )
}
 